import React, { useState } from 'react'

import { Container } from './styles'

const Checkbox = () => {
  const [isChecked, setIsChecked] = useState(false)

  const handleClick = () => {
    setIsChecked((state) => !state)
  }

  return (
    <Container isChecked={isChecked} onClick={handleClick} />
  )
}

export default Checkbox
